<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Edit Translation – {{ languageIso }}</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Title</label>
          <input class="form-control" [(ngModel)]="title" placeholder="Title" type="text">
        </div>
        <div class="form-group mb-3">
          <label>Summary</label>
          <textarea class="form-control" [(ngModel)]="summary" placeholder="Summary" rows="2"></textarea>
        </div>
        <div class="form-group mb-3">
          <label>Content</label>
          <textarea class="form-control" [(ngModel)]="content" placeholder="Content" rows="4"></textarea>
        </div>
        <div class="form-group mb-0">
          <label>Link Button Name</label>
          <input class="form-control" [(ngModel)]="linkButtonName" placeholder="Link button name" type="text">
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Save
        </button>
      </div>
    </div>
  </div>
</div>
